import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const PARAM = "highlightRow";

interface UseRowHighlightOptions {
  dataReady: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export function useRowHighlight({ dataReady, containerRef: externalRef }: UseRowHighlightOptions) {
  const [searchParams] = useSearchParams();
  const [highlightRowId, setHighlightRowId] = useState<string | null>(null);
  const internalRef = useRef<HTMLDivElement>(null);
  const containerRef = externalRef ?? internalRef;

  useEffect(() => {
    const value = searchParams.get(PARAM);
    if (!value || !dataReady) return;

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete(PARAM);
    window.history.replaceState({}, "", currentUrl.toString());

    setHighlightRowId(value);

    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    const timeout = setTimeout(() => {
      requestAnimationFrame(() => {
        const row = document.querySelector("tr.row-highlight") as HTMLElement | null;
        row?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }, 150);

    return () => clearTimeout(timeout);
  }, [dataReady, searchParams, containerRef]);

  return { highlightRowId, containerRef };
}
